import React, { useState } from 'react';
import DataList from '../DataList';
import LeavePaymentVoucherPrint from './LeavePaymentVoucherPrint';

const periodLabel = (start) => {
  const year = Number(String(start || '').slice(0, 4));
  if (!year) return '';
  return `${year}-${year + 1}`;
};

const money = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '';
  return amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const EmployeeLeaveVouchers = ({ employee }) => {
  const [printVoucher, setPrintVoucher] = useState(null);
  const apiConfig = {
    title: 'Payment vouchers',
    path: '/leave-requests',
    fetchEndpoint: `/hospital-portal/api/employees/leave/vouchers?employee_id=${encodeURIComponent(employee.employee_id)}`,
    useLocalCaching: false,
    allowAdd: false,
    allowEdit: true,
    allowDelete: false,
    allowExport: false,
    formTitle: 'Payment voucher',
    updateEndpoint: '/hospital-portal/api/employees/leave/vouchers',
    gcBucketName: 'sh-employees',
    defaultSortFieldId: 'issued_at',
    defaultSortAsc: false,
    tabs: [
      { name: 'Main', roles: 'all', default: true },
    ],
    fields: [
      { name: 'voucher_id', label: 'Voucher', type: 'text', identifier: true, disabled: true, tab: 'Main' },
      { name: 'leave_year_start', label: 'Leave year', type: 'date', disabled: true, tab: 'Main' },
      { name: 'issued_at', label: 'Issued', type: 'date', disabled: true, tab: 'Main' },
      { name: 'standard_amount', label: 'Leave allowance', type: 'number', disabled: true, tab: 'Main' },
      { name: 'forfeited_amount', label: 'Forfeited leave allowance', type: 'number', disabled: true, tab: 'Main' },
      { name: 'total_amount', label: 'Total', type: 'number', disabled: true, tab: 'Main' },
      {
        name: 'signed_documents',
        label: 'Signed Documents',
        type: 'file',
        tab: 'Main',
        accept: 'application/pdf,image/*',
      },
    ],
  };

  const columns = [
    { name: 'ID', selector: (row) => row.voucher_id, identifier: true, omit: true },
    { name: 'Voucher', selector: (row) => row.voucher_id, sortable: true, width: '90px' },
    {
      name: 'Leave year',
      selector: (row) => periodLabel(row.leave_year_start),
      sortable: true,
    },
    {
      id: 'issued_at',
      name: 'Issued',
      selector: (row) => row.issued_at,
      sortable: true,
      type: 'datetime',
    },
    {
      name: 'Forfeited',
      selector: (row) => (row.forfeited ? 'Yes' : 'No'),
      sortable: true,
    },
    { name: 'Total', selector: (row) => money(row.total_amount), sortable: true, right: true },
    {
      name: 'Print',
      ignoreRowClick: true,
      allowOverflow: true,
      cell: (row) => (
        <button
          type="button"
          className="leave-print-link"
          onClick={(event) => {
            event.stopPropagation();
            setPrintVoucher(row);
          }}
        >
          Print
        </button>
      ),
    },
  ];

  return (
    <>
      <DataList apiConfig={apiConfig} columns={columns} />
      {printVoucher && (
        <LeavePaymentVoucherPrint voucher={printVoucher} onClose={() => setPrintVoucher(null)} />
      )}
    </>
  );
};

export default EmployeeLeaveVouchers;
